export default __webpack_public_path__ + "static/media/g41.caa369c8.svg";